module.exports = "/assets/2b7a522d431ea54717b61b3009d36d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MP.png
// module id = 2746
// module chunks = 0